<div class="forecast-container">
    <ng-container *ngIf="forecast|async as forecast; else loadingForecast">
        <div class="forecast-main-panel" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout fxFlex>
                    <button app-small-ghost-button class="app-base-button"
                            (click)="onClickGotoResources(forecast.entity_id)">
                        <app-icon name="fal-arrow-left"></app-icon>
                        {{'Back to resources'|i18n}}
                    </button>
                </div>
            </div>
            <div fxLayout="row" class="mt-32" fxLayoutAlign="start center">
                <div fxLayout="row" class="bg-3">
                    <app-forecast-details-new [forecast]="forecast">
                    </app-forecast-details-new>
                </div>
            </div>
            <div *appVar="forecastQuantities|async as fqs" fxFill fxLayout="column"
                 class="forecast-quantities mt-32" fxLayoutGap="24px">
                <div *ngIf="!fqs.length" fxLayout="row" fxLayoutAlign="center" class="measure-box">
                    {{'No forecast data available'|i18n}}
                </div>
                <div fxLayout="column" fxLayoutAlign="start stretch"
                     *ngFor="let fq of fqs|sortArray:'quantityName'; let first=first">
                    <div [ngClass]="{'mt-48':!first}"  class="measure-box">
                        <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="txt-h-18-7 mr-24">
                            <span><app-icon *ngIf="fq.icon" [name]="fq.icon"></app-icon>&nbsp;{{fq.quantityName}}</span>
                            <span *ngIf="fq.model" class="forecast-quantity-model ml-8">({{fq.model}})</span>
                        </span>
                            <ng-container *ngIf="fq.data.length > 0">
                                <div *ngIf="dataSources[fq.quantityType] === DataSource.STATISTICAL"
                                     fxLayout="row"
                                     fxLayoutAlign="start center" fxLayoutGap="10px"
                                     class="txt-p-16-4 forecast-quantity-name">
                                    <app-icon name="fal-chart-network"></app-icon>
                                    <span>{{'Statistical data'|i18n}}</span>
                                    <app-icon name="fas-info-circle"
                                              [title]="'Energy data are estimated on GSE-defined statistical profiles and previous year\'s readings, in similar seasonality, and based on rate ranges'|i18n">
                                    </app-icon>
                                </div>
                                <div *ngIf="dataSources[fq.quantityType] === DataSource.MONITORED"
                                     fxLayout="row"
                                     fxLayoutAlign="start center" fxLayoutGap="10px"
                                     class="txt-p-16-4 forecast-quantity-name">
                                    <app-icon name="fal-radar"></app-icon>
                                    <span>{{'Forecasts from monitored data'|i18n}}</span>
                                    <app-icon name="fas-info-circle"
                                              [title]="'Forecasts based on energy data collected using smart meters'|i18n">
                                    </app-icon>
                                </div>
                            </ng-container>
                        </div>
                        <div class="forecast-quantity">
                            <app-line-chart *ngIf="fq.data.length"
                                            [data]="[{data: fq.data, style: {color: fq.color, strokeWidth: 1.5}}]"
                                            [margins]="{left:75, right: -20}"
                                            [yTickFormatter]="fq.uom|yTickFormatter"
                                            [tooltipFormatter]="fq.uom|tooltipFormatter:TIME_DELTA_QUARTER_HOUR"
                                            [xGrid]="true"
                                            [yGrid]="true"
                                            [gridColor]="gridColor"
                                            [tooltipBorderColor]="tooltipBorderColor"
                                            [tooltipBackgroundColor]="tooltipBackgroundColor"
                                            [selectionLineColor]="selectionLineColor"
                                            [xTickSpace]="80"
                                            [yTickSpace]="30"
                                            [resizeTrigger]="contentResize">
                            </app-line-chart>
                        </div>
                        <div *ngIf="!fq.data.length" fxLayout="row" fxLayoutAlign="center" class="mt-24">
                            <app-icon name="fal-exclamation-circle"></app-icon>&nbsp;
                            <span class="pl-8">{{'No data forecast'|i18n}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #loadingForecast>
    <div fxLayout="column">
        <div fxLayout="row inline" fxFlexAlign="center" class="mt-24 mb-16">
            <mat-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{'Loading forecast'|i18n}}...</span>
        </div>
    </div>
</ng-template>
